export default {"src":"/_next/static/media/arrow-button-quiz-right-white.73b28728.svg","height":14,"width":20,"blurWidth":0,"blurHeight":0};